import React, { createContext, useCallback, useMemo, useState } from "react";
import { Party } from "../types";

interface PartyContextData {
  party: Party[];
  setParty: (party: Party[]) => void;
}

export const PartyContext = createContext<PartyContextData>({
  party: [],
  setParty: () => {},
});

export const PartyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [party, setPartiesState] = useState<Party[]>([]);
  const setParty = useCallback((party: Party[] | []) => {
    setPartiesState(party);
  }, []);

  const value = useMemo(() => ({ party, setParty }), [party, setParty]);

  return (
    <PartyContext.Provider value={value}>
      {children}
    </PartyContext.Provider>
  );
};
